import React, { useState, useEffect } from "react";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import { TableLoader } from "../../../../Common/ShimmerLoader";
//import { innergetAllZoneWiseReport } from "../../../Apis/satReportsApi";
import {
  ZonewiseTripsReport
} from "../../../../Apis/ttrReportsApi";
import CustomDataTable from "../../../../Common/ReportTable/ReportTable";

import ExcelJS from "exceljs";

const ZoneWiseTrips = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [getZoneInnerReport, setgetZoneInnerReport] = useState([]);
  const [data, setData] = useState(null);
  const location = useLocation()

  useEffect(() => {
    if (location.state) {
      setData(location.state); // Set data when it's available
    } else {
      fetchData(); // Fetch data when component mounts if state is not available
    }
  }, [location.state]);

  const fetchData = async (ZoneId, VehicleTypeId) => {
    try {
      setIsLoading(true);
      // Perform the API call again to fetch data
      const requestData = { Date, VehicleTypeId, ZoneId }; // Assuming these are defined somewhere
      const response = await ZonewiseTripsReport(requestData);
      setData(response.data);
    } catch (error) {
      console.error("Error fetching zone wise report:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // const data = location.state
  const [zonesData, setZonesData] = useState([]);


  const zoneReportColumns = [
    {
      name: "Sl.No",
      selector: (row) => row["slno"],
      sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
    },
    {
      name: "TS Name",
      selector: (row) => row["transferStationName"],
      cell: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["transferStationName"] || "N/A"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Zone",
      selector: (row) => row["zoneNAME"],
      cell: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //  onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["zoneNAME"] || "N/A"}
        </span>
      ),
      sortable: true,
    },

    {
      name: "GHMC Trips",
      selector: (row) => row["ghmcTrips"],
      cell: (row) => (
        <span
        // style={{ color: "blue" }}
        > {row["ghmcTrips"]}</span>
      ),
      sortable: true,
    },
    {
      name: "HIRE Trips",
      selector: (row) => row["hireTrips"],
      cell: (row) => (
        <span
        //style={{ color: "blue" }}
        >{row["hireTrips"]}</span>
      ),
      sortable: true,
    },
    {
      name: "HIMSW Trips",
      selector: (row) => row["himswTrips"],
      cell: (row) => (
        <span
        //style={{ color: "blue" }}
        >{row["himswTrips"]}</span>
      ),
      sortable: true,
    },
    {
      name: "Total Trips",
      selector: (row) => row["totalTrips"],
      cell: (row) => (
        <span
        //  style={{ color: "blue" }}
        >{row["totalTrips"]}</span>
      ),
      sortable: true,
    },
    {
      name: "GHMC Tonnage",
      selector: (row) => row["ghmcTonnage"],
      cell: (row) => (
        <span
        //style={{ color: "blue" }}
        >{row["ghmcTonnage"]}</span>
      ),
      sortable: true,
    },
    {
      name: "HIRE Tonnage",
      selector: (row) => row["hireTonnage"],
      cell: (row) => (
        <span
        // style={{ color: "blue" }}
        >{row["hireTonnage"]}</span>
      ),
      sortable: true,
    },
    {
      name: "HIMSW Tonnage",
      selector: (row) => row["himswTonnage"],
      cell: (row) => (
        <span
        //style={{ color: "blue" }}
        >{row["himswTonnage"]}</span>
      ),
      sortable: true,
    },
    {
      name: "Total Tonnage",
      selector: (row) => row["totalTonnage"],
      cell: (row) => (
        <span
        //style={{ color: "blue" }}
        >{row["totalTonnage"]}</span>
      ),
      sortable: true,
    },
  ];
  const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
  const generationTime = ` ${new Date().toLocaleString('en-GB', options).replace(/\//g, '/')}`;

  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1
      }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = ` Zone Wise Trips Report Generated on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zone Wise Trips & Tonnage Report");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
    worksheet.mergeCells(1, 2, 1, 4); // Merge cells for downloadDateTime from column 2 to 4
    worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
    worksheet.getCell(1, 2).font = boldFont; // Set font style
    worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B1, C1, D1)
    for (let col = 2; col <= 4; col++) {
      worksheet.getCell(1, col).font = boldFont; // Set styles individually
      worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add "Zone Details" to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", "Zone Wise Trips Details", ""]); // Update array length to match new cell range
    worksheet.mergeCells(2, 2, 2, 4); // Merge cells for Zone Details from column 2 to 4
    worksheet.getCell(2, 2).value = "Zone Wise Trips Details"; // Ensure the value is set after merging
    worksheet.getCell(2, 2).font = boldFont; // Set font style
    worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B2, C2, D2)
    for (let col = 2; col <= 4; col++) {
      worksheet.getCell(2, col).font = boldFont; // Set styles individually
      worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    const tableHeaderRow = worksheet.addRow([
      "Sno",
      "TS Name",
      "Zone",
      "GHMC Trips",
      "HIRE Trips",
      "HIMSW Trips",
      "Total Trips",
      "GHMC Tonnage",
      "HIRE Tonnage",
      "HIMSW Tonnage",
      "Total Tonnage"
    ]);
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left", color: "#fff" }; // Center align the cell content
      if (colNumber >= 1 && colNumber <= 11) {
        // Apply background color and set text color
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
          bgColor: { argb: "FFFFFFFF" } // White text color
        };
      }
    });

    // Add data rows
    data.forEach((item, index) => {

      worksheet
        .addRow([
          index + 1,
          item.transferStationName ?? "N/A",
          item.zoneNAME ?? "N/A",
          item.ghmcTrips ?? "N/A",
          item.hireTrips ?? "N/A",
          item.himswTrips ?? "N/A",
          item.totalTrips ?? "N/A",
          item.ghmcTonnage ?? "N/A",
          item.hireTonnage ?? "N/A",
          item.himswTonnage ?? "N/A",
          item.totalTonnage ?? "N/A"

        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 11) {
            // Align the columns from 1 to 4 to the left
            cell.alignment = { horizontal: "left" };
          } else {
            // Align the rest of the columns to the center
            cell.alignment = { horizontal: "center" };
          }
        });
    });

    // Add total row with bold font


    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 17 },
      { width: 15 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "ZoneWiseTrips.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="top-header page-title">
              <span>{" "}
                    Zone Wise Trips & Tonnage Report</span>
            </div>
            <div className="page-header"></div>
            <div class="row" style={{ textAlign: "justify" }}>
            </div>
            <div className="card">
              <div className="card-body p-3">
                <div className="d-flex justify-content-end mt-3 mb-3">
                  <button className="btn btn-secondary  me-2" style={{}}
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </button>
                  <button className="btn btn-excel" style={{ backgroundColor: "#EC1117" }}
                    onClick={downloadAsExcel}
                  >
                    <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                  </button>

                </div>

                {data &&
                  <CustomDataTable
                    data={data}
                    columns={zoneReportColumns}
                  // headers={headers}
                  // link={true}
                  // search={true}
                  // fromDate={fromDate}
                  // toDate={toDate}
                  />
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ZoneWiseTrips;
